<div class="ddc-card-category" matTooltip="Category: {{ category }}">
  <mat-icon class="category-icon">category</mat-icon>
  <span class="category-text">{{ category }}</span>
</div>
